module.exports = __webpack_public_path__ + "static/img/mrt_logo_black.cc40248.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mrt_logo_black.png
// module id = hOie
// module chunks = 1